<template>
  <span
    class="tw:inline-flex tw:h-9 tw:items-center tw:gap-2 tw:rounded-lg tw:border tw:border-gray-300 tw:bg-white tw:py-0 tw:pl-2 tw:pr-3 tw:shadow-[0_1px_2px_0_rgb(16_24_40_/_0.05)]"
    :class="modelValue ? 'tw:border-solid' : 'tw:border-dashed'"
    data-testid="color-chip">
    <PopsColorPicker
      :model-value="modelValue"
      :size="20"
      :default-alpha="1"
      :show-hex="!!modelValue"
      data-testid="color-chip-trigger"
      @update:model-value="emit('update:modelValue', $event)" />

    <span v-if="label" class="tw:text-12 tw:text-muted">{{ label }}</span>
    <span v-if="!modelValue" class="tw:text-12 tw:italic tw:text-muted" data-testid="color-chip-unset">
      {{ $t('brand.colour_not_set') }}
    </span>

    <button
      v-if="removable"
      type="button"
      class="tw:ml-1 tw:flex tw:size-4 tw:items-center tw:justify-center tw:text-muted hover:tw:text-gray-900"
      data-testid="color-chip-remove"
      :aria-label="$t('brand.colour_remove')"
      @click.stop="emit('remove')">
      <IconX :size="14" />
    </button>
  </span>
</template>

<script setup lang="ts">
import { PopsColorPicker } from '@prospective/pops-client-vue';
import { IconX } from '@tabler/icons-vue';

interface Props {
  modelValue: string;
  /** the role shown after the picker's value, e.g. "Primary" */
  label?: string;
  /** shows a remove action, used by the colours a registrant added themselves */
  removable?: boolean;
}

withDefaults(defineProps<Props>(), {
  label: '',
  removable: false,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
  (e: 'remove'): void;
}>();
</script>
